import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useI18n } from 'vue-i18n';

import CopyableText from './CopyableText.vue';
import CustomModal from './CustomModal.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordView',
  props: {
    email: {
        type: String,
        required: false,
        default: '',
    },
    password: {
        type: String,
        required: false,
        default: '',
    },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;


const { t } = useI18n();



const closeModal = () => {
    emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomModal, { onClose: closeModal }, {
    "modal-header": _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(_unref(t)('passwordView.title')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(CopyableText, {
        text: props.email
      }, null, 8, ["text"]),
      _createVNode(CopyableText, {
        text: props.password
      }, null, 8, ["text"]),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('passwordView.subtext')), 1)
    ]),
    _: 1
  }))
}
}

})